@use '../../styling/typography.scss' as *;
@use '../../styling/colors.scss' as *;

.Header {
  @extend %font-family-primary;
  @extend %font-weight-bold;

  color: $theme-color-header;
  padding-top: 10px;
  margin: 0;

  &.hasBorderBottom {
    border-bottom: 1px solid $theme-color-borders;
  }

  &.noTopMargin {
    padding-top: 0;
    margin-top: 0;
  }

  &.noBottomMargin {
    padding-bottom: 0;
    margin-bottom: 0;
  }

  &.lessWeight {
    @extend %font-weight-semibold;
  }
}

h1.Header {
  font-size: 23px;
}

h2.Header {
  font-size: 20px;
}

h3.Header {
  font-size: 17px;
}

h4.Header {
  @extend %font-weight-semibold;

  font-size: 16px;
}

h5.Header {
  @extend %font-weight-semibold;

  font-size: 14px;
}
